import { render, staticRenderFns } from "./SpookLoader.vue?vue&type=template&id=21003288&"
import script from "./SpookLoader.vue?vue&type=script&lang=js&"
export * from "./SpookLoader.vue?vue&type=script&lang=js&"
import style0 from "./SpookLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
